/**
 * @module ScopeService
 *
 * Controls feature visibility based on the current user's scopes.
 *
 * ## Key rules
 * - When `impersonation` is active, the impersonated user's scopes are
 *   used instead of the profile's.
 * - No `augintel_admin` bypass: admins get exactly the scopes on their user.
 *
 * @example
 * if (getActiveScopes(profile, impersonation).includes('monitors_enabled_in_elevate')) { ... }
 */
type ScopeProfile = { user_type: string; scopes: string[] } | null;
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
type ScopeImpersonation = { scopes?: string[] } | null | unknown;

export const getActiveScopes = (
  profile: ScopeProfile,
  impersonation: ScopeImpersonation): string[] => {
  const imp = impersonation as { scopes?: string[] } | null;
  return (imp ? imp.scopes : profile?.scopes) || [];
};
